import React, { useEffect, useState } from 'react';
import './NotFound.css';

const NotFound = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch('/api/site-settings')
      .then((r) => r.json())
      .then(setSettings)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (settings?.custom404RedirectUrl) {
      const timer = setTimeout(() => {
        window.location.href = settings.custom404RedirectUrl;
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [settings]);

  return (
    <div className="not-found-page">
      <h1>{settings?.custom404Title || '404 — Page Not Found'}</h1>
      <p>{settings?.custom404Message || 'The page you are looking for does not exist.'}</p>
      <button type="button" className="not-found-home-btn" onClick={() => { window.history.pushState({}, '', '/'); window.dispatchEvent(new PopStateEvent('popstate')); }}>
        Go to Homepage
      </button>
      {settings?.custom404RedirectUrl && (
        <p className="not-found-redirect-msg">Redirecting in 5 seconds...</p>
      )}
    </div>
  );
};

export default NotFound;
